import { I18n } from '@calendly/i18n';
import { Icon } from '@calendly/ui/components/icon';
import { LocationPinIcon, VideoIcon } from '@calendly/ui/components/icons';
import { textColorL2 } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const styledIconCss = "s1nzp7d0";
const StyledIcon = forwardRef((props, ref) => <Icon ref={ref} {...props} className={classNames(styledIconCss, props.className)} />);
const webConferencingKinds = ['zoom_conference', 'google_conference', 'microsoft_teams_conference', 'webex_conference', 'gotomeeting_conference'];
const FormattedLocation = ({
  iconName,
  icon,
  locationText
}) => <div>
    {icon || <StyledIcon name={iconName} size="large" color={textColorL2} />}
    {locationText}
  </div>;

// i18n-tasks-use t('booking.location.google_conference.label')
// i18n-tasks-use t('booking.location.gotomeeting_conference.label')
// i18n-tasks-use t('booking.location.zoom_conference.label')
// i18n-tasks-use t('booking.location.inbound_call.label')
// i18n-tasks-use t('booking.location.outbound_call.label')
// i18n-tasks-use t('booking.location.ask_invitee.label')
// i18n-tasks-use t('booking.location.microsoft_teams_conference.label')
// i18n-tasks-use t('booking.location.webex_conference.label')
export const Location = ({
  locationConfiguration
}) => {
  let iconName = 'location';
  let icon = <LocationPinIcon size="large" spacingRight={8} color={textColorL2} />;
  if (!locationConfiguration) {
    return <FormattedLocation icon={icon} iconName={iconName} locationText={I18n.t('publisher.scheduled_events.pending.booking_modal.no_location_given')} />;
  }
  let locationText = locationConfiguration.location;
  if (locationConfiguration.kind === 'inbound_call') {
    icon = null;
    iconName = 'phone';
    locationText = locationConfiguration.phone_number;
  }
  if (webConferencingKinds.includes(locationConfiguration.kind)) {
    icon = <VideoIcon size="large" spacingRight={8} color={textColorL2} />;
    iconName = null;
    locationText = I18n.t(`booking.location.${locationConfiguration.kind}.label`);
  }
  return <FormattedLocation icon={icon} iconName={iconName} locationText={locationText} />;
};

require("./location.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./location.js");